async function loadAllEventProducts() {
  const handle = window.__eventCollectionHandle;

  let finished = false;   
  let allProducts = [];   

  while (!finished) {
    const response = await fetch(
      `https://animamundiherbals.com/collections/${handle}?section_id=ticket-js-section`
    );

    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const scriptTag = doc.querySelector("script");

    if (!scriptTag || !scriptTag.innerText.includes("window.__rawEventProducts")) {
      console.warn("No product data found in returned section");
      finished = true;
      break;
    }
    const match = scriptTag.innerText.match(/window.__rawEventProducts\s*=\s*(\[[\s\S]*?\]);/);

    if (match && match[1]) {
      try {
        const products = JSON.parse(match[1]);
        allProducts = allProducts.concat(products);
      } catch (err) {
        console.error("JSON parse error: ", err);
      }
    }

    finished = true;
  }

  window.__rawEventProducts = allProducts;
}


function mainTicketCalendar() {
  // --- Parse human readable date into YYYY-MM-DD ---
  let currentFilterProduct = ""; 
  let currentFilterLocation = "all"; // default value
  
  function parseHumanDate(humanDate) {
    if (!humanDate) return null;
  
    // Remove ordinal suffixes (1st, 2nd, 3rd, etc.)
    humanDate = humanDate.replace(/(\d+)(st|nd|rd|th)/g, "$1");
  
    const dateObj = new Date(humanDate);
    if (isNaN(dateObj)) return null;
  
    const yyyy = dateObj.getFullYear();
    const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
    const dd = String(dateObj.getDate()).padStart(2, "0");
  
    return `${yyyy}-${mm}-${dd}`;
  }
  
  // --- Transform raw products into events ---
  const events = (window.__rawEventProducts || [])
    .map((product) => {
      // Convert variant dates
      const variants = (product.variants || [])
        .map((v) => {
          const parsedDate = parseHumanDate(v.date);
          return {
            date: parsedDate,
            time: v.time || "",
            available: v.available,
            price: v.price,
            variantId: v.v_id,
            attendees: v.attendees || "", 
  
          };
        })
        .filter((v) => v.date); // only keep valid dates
  
      // If no valid dates, skip
      if (variants.length === 0 && !parseHumanDate(product.date)) return null;
  
      return {
        id: product.id,
        image:product.image,
        url:product.url,
        title: product.title,
        description: product.description,
        eventbrite_link: product.eventbrite_link,
        handle : product.handle,
        instructor: product.instructor,
        duration: product.duration,
        location: product.location,
        host: product.host,
        price: product.base_price,
        category: product.type,
        productHandle: product.handle,
        hasTimeslots: variants.length > 0,
        timeslots: variants,
        is_free_event: product.is_free_event,
        side_card_btn_text: product.side_card_btn_text,
        popup_btn_text: product.popup_btn_text,
        date: variants.length > 0 ? variants[0].date : parseHumanDate(product.date),
        attendees: variants.length > 0 ? variants[0].attendees : product.attendees,
        recurring: product.recurring || false,
        _calendarBgColor: product._calendarBgColor || "",
      };
    })
    .filter(Boolean); // remove null events
    
  window.__processedEvents = events;
  
  // console.table(
  //   events.map((e) => ({
  //     title: e.title,
  //     date: e.date,
  //     slots: e.timeslots.map((s) => s.date).join(", "),
  //   }))
  // );
  
  // --- Calendar State ---
  let currentDate = new Date();
  currentDate.setDate(1);
  let selectedTimeslot = null;
  
  // --- Render Calendar ---
  function renderCalendar(filterProduct = "", filterLocation = "") {
    const calendar = document.getElementById("calendar");
    calendar.innerHTML = "";
  
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
  
    // Empty cells before the first day
    for (let i = 0; i < firstDay; i++) {
      const emptyCell = document.createElement("div");
      emptyCell.className = "empty-cell";
      calendar.appendChild(emptyCell);
    }
  
    // Days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const dayElement = document.createElement("div");
      dayElement.className = "calendar-day";
  
      const dayNumber = document.createElement("div");
      dayNumber.className = "day-number";
      dayNumber.textContent = day;
      dayElement.appendChild(dayNumber);
  
      const dayEvents = getEventsForDay(year, month, day);
      dayEvents.forEach((event) => {
        const eventDot = document.createElement("span");
        eventDot.className = "event-dot";
        eventDot.style.backgroundColor = event._calendarBgColor || window._calendarBgColor;
        eventDot.style.color = _calendarTextColor;
  

        //  Add class if this date has any events
        if (dayEvents.length > 0) {
          dayElement.classList.add("event-calendar");
        }
  
        let mql = window.matchMedia("(max-width: 600px)");
          if (mql.matches) {
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "18");
            svg.setAttribute("height", "18");
            svg.setAttribute("viewBox", "0 0 64 64");
  
            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute("fill", "none");
            path.setAttribute("stroke", "#000");
            path.setAttribute("stroke-width", "2");
            path.setAttribute("d", "M1,32c0,0,11,15,31,15s31-15,31-15S52,17,32,17S1,32,1,32z");
  
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("fill", "none");
            circle.setAttribute("stroke", "#000");
            circle.setAttribute("stroke-width", "2");
            circle.setAttribute("cx", "32");
            circle.setAttribute("cy", "32");
            circle.setAttribute("r", "7");
  
            svg.appendChild(path);
            svg.appendChild(circle);
            eventDot.innerHTML = ""; // Clear existing content
            eventDot.appendChild(svg);
        } else {
            eventDot.textContent = event.title;
        }
  
  
        // Add data attributes
        eventDot.dataset.product = event.title;
        eventDot.dataset.location = event.location;
  
        // Add hidden if doesn't match filters
        const trimmedFilterProduct = (filterProduct || "").trim();
        const trimmedFilterLocation = (filterLocation || "all").trim();
        const trimmedEventTitle = (event.title || "").trim();
        const trimmedEventLocation = (event.location || "").trim();

        if (
          (trimmedFilterProduct !== "" && trimmedFilterProduct !== trimmedEventTitle) ||
          (trimmedFilterLocation !== "all" && trimmedFilterLocation !== trimmedEventLocation)
        ) {
          eventDot.classList.add("hidden-event");
        }
  
        // Dot click opens modal for this specific event
        const dateString = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  
        eventDot.addEventListener("click", (e) => {
          e.stopPropagation(); // prevent day-level handler from also firing
          showEventModal(event, dateString);
  
          //  When popup opens
          document.body.classList.add('no-scroll');
        });
  
        dayElement.appendChild(eventDot);
      });
  
      // --- Day-level click handler: open modal for first event of the day ---
      // Guard so we don't add multiple listeners if renderCalendar runs repeatedly
      if (!dayElement.dataset.listenerAttached) {
        dayElement.addEventListener("click", (e) => {
          // If the click originated inside an .event-dot, do nothing here
          if (e.target.closest && e.target.closest(".event-dot")) return;
  
          if (dayEvents.length === 0) return; // nothing to open
  
          const dateString = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
          // Open modal for the first event of that day (you can change this to pick a specific event)
          showEventModal(dayEvents[0], dateString);
        });
  
        // mark as attached
        dayElement.dataset.listenerAttached = "true";
      }
  
      calendar.appendChild(dayElement);
    }
  }
  
  // --- Get events for a day ---
  function getEventsForDay(year, month, day) {
    const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
  
    return events.filter((event) => {
      if (event.recurringDates) {
        return event.recurringDates.includes(dateStr);
      }
      if (event.hasTimeslots) {
        return event.timeslots.some((slot) => slot.date === dateStr);
      }
      return event.date === dateStr;
    });
  }
  
  // --- Render events list (sidebar or homepage preview) ---
  function renderEventsList(filterProduct = "", filterLocation = "all") {
    const eventsList = document.getElementById("eventsList");
    if (!eventsList) return;
    eventsList.innerHTML = "";
  
    // --- Emoji/label setup ---
    let emojiData = document.querySelector(".event-calendar-section")?.dataset.upcomingEventsLines || "{}";
    let emojiMap = {};
    try {
      emojiMap = JSON.parse(emojiData);
    } catch (err) {
      console.warn("Invalid emoji mapping in dataset, using defaults.");
    }
  
    const defaultEmojis = {
      date: "📅|Date",
      time: "⏰|Time",
      location: "📍|Location",
      instructor: "👨‍🏫|Instructor",
      attendees: "👥|Attendees",
      price: "💰|Price",
    };
  
    function getEmojiLabel(key) {
      let pair = emojiMap[key] || defaultEmojis[key];
      if (!pair) return "";
      const [emoji, label] = pair.split("|");
      return `<strong>${emoji} ${label}:</strong>`;
    }
     window.getEmojiLabel = getEmojiLabel;
  
    // --- Today's date ---
    const today = new Date();
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  
    // --- Filter upcoming events ---
    const upcomingEvents = events
      .filter(event => {
        const trimmedFilterProduct = (filterProduct || "").trim();
        const trimmedFilterLocation = (filterLocation || "all").trim();
        const trimmedEventTitle = (event.title || "").trim();
        const trimmedEventLocation = (event.location || "").trim();

        // Filter by product or location if provided
        if (trimmedFilterProduct !== "" && trimmedFilterProduct !== trimmedEventTitle) return false;
        if (trimmedFilterLocation !== "all" && trimmedFilterLocation !== trimmedEventLocation) return false;
  
        // Only future events
        if (event.hasTimeslots) {
          return event.timeslots.some(slot => slot.date > todayStr);
        } else {
          return event.date > todayStr;
        }
      })
      .sort((a, b) => {
        const aDate = a.hasTimeslots ? a.timeslots.find(slot => slot.date > todayStr)?.date : a.date;
        const bDate = b.hasTimeslots ? b.timeslots.find(slot => slot.date > todayStr)?.date : b.date;
        return (aDate || "").localeCompare(bDate || "");
      })
      .slice(0, 4); // limit to 4
  
    // --- Render ---
    if (upcomingEvents.length === 0) {
      eventsList.innerHTML = `<p class="no-events">No upcoming events found.</p>`;
      return;
    }
  
    upcomingEvents.forEach((event) => {
      const eventCard = document.createElement("div");
      eventCard.className = "event-card";
      eventCard.onclick = () => showEventModal(event);
  
      // Get next valid date
      let displayDate = event.date;
      if (event.hasTimeslots) {
        const nextSlot = event.timeslots.find(slot => slot.date > todayStr);
        if (nextSlot) displayDate = nextSlot.date;
      }
  
      const [yyyy, mm, dd] = displayDate.split("-");
      const formattedDate = `${mm}/${dd}/${yyyy}`;
  
      eventCard.innerHTML = `
        <div class="category-tag category-${event.category}">${event.category}</div>
        <h4>${event.title}</h4>
        <div class="event-meta">
          <div class="modal-meta-wrapper">
            <div class="modal-meta-Information">
            <div class="model-icon-wrapper"><img src="${window._icon.date}" alt="date icon" class="icon-event" loading="lazy"> <span><strong>${window._labels.date}:</strong> ${formattedDate}${event.recurring ? " (recurring monthly)" : ""}</span></div>
            <div class="model-icon-wrapper"><img src="${window._icon.time}" alt="time icon" class="icon-event" loading="lazy"><span><strong>${window._labels.time}:</strong> ${event.hasTimeslots ? (event.timeslots.length > 1 ? "Multiple slots" : `${event.timeslots[0].time || "TBD"} (${event.duration || ""})` ): `${event.time || "TBD"} (${event.duration || ""})`} </span> </div>
            <div class="model-icon-wrapper js-location"><img src="${window._icon.location}" alt="location icon" class="icon-event" loading="lazy"> <span><strong>${window._labels.location}:</strong> ${event.location}</span></div>
            <div class="model-icon-wrapper"><img src="${window._icon.Instructor}" alt="Instructor" class="icon-event" loading="lazy"> <strong>${window._labels.instructor}:</strong> ${event.instructor}</div>
            <div class="model-icon-wrapper"><img src="${window._icon.attendees}" alt="Attendees icon" class="icon-event" loading="lazy"> <span><strong>${window._labels.attendees}:</strong> ${event.attendees || "1/1"}</span></div>
            <div class="model-icon-wrapper"><img src="${window._icon.price}" alt="price icon" class="icon-event" loading="lazy"> <span><strong>${window._labels.price}:</strong> $${event.price}</span></div>
          </div>
          <div class="modal-meta-image">
            <img src="${event.image || ''}" alt="${event.title}" loading="lazy" width="200px">
            </div>
          </div>
        </div>
        <div class="event-footer">
          <span class="event-price">$${event.price}</span>
          <button class="event-btn button button--small" ${event.timeslots && event.timeslots.length === 1 ? `onclick="event.stopPropagation(); window.bookDirectly(${event.id}, this);"` : ""}>
            ${event.side_card_btn_text || "View Times"}
          </button>
        </div>
      `;
  
      eventsList.appendChild(eventCard);
    });
  }
  
  
  
  
  
  // --- Modal ---
  function showEventModal(event, selectedDate = null) {
    const modal = document.getElementById("eventModal");
    const modalContent = document.getElementById("modalContent");
    window.currentModalEvent = event;
    selectedTimeslot = null;
  
    // --- Ensure selectedDate is provided, otherwise fallback to first date with slots ---
    if (!selectedDate && event.hasTimeslots) {
      const todayStr = new Date().toISOString().split("T")[0]; // current date in YYYY-MM-DD
      const upcomingDates = [...new Set(event.timeslots.map(slot => slot.date))].sort();
      selectedDate = upcomingDates.find(date => date > todayStr) || upcomingDates[0];
    }
  
    // --- Filter timeslots for the selected date only ---
    let filteredTimeslots = [];
    if (event.hasTimeslots && selectedDate) {
      filteredTimeslots = event.timeslots.filter(slot => slot.date === selectedDate);
    }
  
    // --- Build timeslot HTML ---
    let timeslotsHTML = "";
    if (event.hasTimeslots && filteredTimeslots.length > 0) {
  
      //  Only ONE slot and it is available → auto select + no choice UI
      if (filteredTimeslots.length === 1 && filteredTimeslots[0].available) {
        const slot = filteredTimeslots[0];
        selectedTimeslot = slot.time;
        selectedVariantId = slot.variantId;
  
        timeslotsHTML = `
          <div class="timeslots single-timeslot">
            <h4>Time: <strong>${slot.time}</strong> (${event.duration || ""})</h4>
            <p>This is the only available time for this date.</p>
          </div>
        `;
  
        //  Auto-enable button
        setTimeout(() => {
          const bookBtn = document.getElementById("bookBtn");
          if (bookBtn) {
            bookBtn.disabled = false;
            bookBtn.textContent = event.popup_btn_text || "Book This Time";
          }
        }, 50);
  
      } else {
        //  Multiple slots → show selection grid
        timeslotsHTML = `
          <div class="timeslots">
            <h4>Available Time Slots (${event.duration || "each"}):</h4>
            <div class="timeslot-grid">
              ${filteredTimeslots.map(slot => `
                <div class="timeslot ${slot.available ? "" : "booked"}"
                    onclick="${slot.available ? `selectTimeslot('${slot.time}', this)` : ""}"
                    data-time="${slot.time}" data-Variant-id="${slot.variantId}">
                  ${slot.time}${slot.available ? "" : " (booked)"}
                </div>`).join("")}
            </div>
            <div id="selectedTime" style="margin-top: 10px; font-weight: 600; color: var(--anima-sage-dark);"></div>
          </div>
        `;
      }
  
    } else if (event.hasTimeslots) {
      timeslotsHTML = `<p>No available times for this date.</p>`;
    }
  
    // --- Format selectedDate as DD/MM/YYYY ---
    let formattedDate = selectedDate || event.date;
    if (formattedDate && formattedDate.includes("-")) {
      const [yyyy, mm, dd] = formattedDate.split("-");
      formattedDate = `${mm}/${dd}/${yyyy}`;
    }
  
    // --- Get emoji map from data attribute ---
    let emojiData = document.querySelector(".event-calendar-section")?.dataset.popupEventsLines || "{}";
    // console.log(emojiData)
    let emojiMap = {};
    try {
      emojiMap = JSON.parse(emojiData);
    } catch (err) {
      console.warn("Invalid emoji mapping in dataset, using defaults.");
    }
  
    // --- Default emoji/label map ---
    const defaultEmojis = {
      date: "📅|Date",
      time: "⏰|Time",
      instructor: "👨‍🏫|Instructor",
      location: "📍|Location",
      host: "🏠|Host",
      attendees: "👥|Attendees",
      price: "💰|Price"
    };
  
    // --- Helper: get emoji + label safely ---
    function getEmojiLabel(key) {
      console.log(emojiMap)
      let pair = emojiMap[key] || defaultEmojis[key];
      if (!pair) return "";
      const [emoji, label] = pair.split("|");
      return `<strong>${emoji} ${label}:</strong>`;
    }
    // console.log(event);

    let actionButtonHTML;

    if (event.eventbrite_link) {
      actionButtonHTML = `
        <a href="${event.eventbrite_link}" class="modal-btn button">
          Book on Eventbrite
        </a>
      `;
    } else {
      actionButtonHTML = `
        <button class="modal-btn button js-modal-btn" id="bookBtn"
          onclick="bookEvent('${event.productHandle}')"
          ${event.hasTimeslots ? "disabled" : ""}>
          ${event.hasTimeslots ? "Select Time First" : "Go to Product Page"}
        </button>
      `;
    }
    
  
    // --- Render modal content dynamically ---
    modalContent.innerHTML = `
      <div class="category-tag category-${event.category}">${event.category}</div>
      <p>${event.title}</p>
      <div class="modal-body">
        <div class="modal-meta-wrapper">
          <div class="modal-meta-Information">
            <div class="model-icon-wrapper"><img src="${window._icon.date}" alt="Date icon" class="icon-event" loading="lazy"> <strong>${window._labels.date}:</strong> ${formattedDate}${event.recurring ? " (recurring monthly)" : ""}</div>
            <div class="model-icon-wrapper"><img src="${window._icon.time}" alt="time icon" class="icon-event" loading="lazy"> <strong>${window._labels.time}:</strong> ${event.hasTimeslots ? (event.timeslots.length === 1 ? `${event.timeslots[0].time || "TBD"} (${event.duration || ""})` : "Select from available slots") : `${event.time || "TBD"} (${event.duration || ""})`} </div>
            <div class="model-icon-wrapper"><img src="${window._icon.location}" alt="location icon" class="icon-event" loading="lazy"> <strong>${window._labels.location}:</strong>${event.location}</div>
            <div class="model-icon-wrapper"><img src="${window._icon.Instructor}" alt="Instructor" class="icon-event" loading="lazy"> <strong>${window._labels.instructor}:</strong>${event.instructor}</div>
            <div class="model-icon-wrapper">${event.host ? `${getEmojiLabel("host")} ${event.host}<br>` : ""}</div>
            <div class="model-icon-wrapper"><img src="${window._icon.attendees}" alt="attendees" class="icon-event" loading="lazy"> <strong>${window._labels.attendees}:</strong>${event.attendees}</div>
            <div class="model-icon-wrapper"><img src="${window._icon.price}" alt="price" class="icon-event" loading="lazy"> <strong>${window._labels.price}:</strong>$${event.price}</div>
            <a href="${event.url}" class="model-event-btn">Learn more</a>
          </div>
          <div class="modal-meta-image">
            <img src="${event.image || ''}" alt="${event.title}" loading="lazy" width="200px">
          </div>
        </div>
        ${timeslotsHTML}
        <div class="modal-actions">
          <button class="modal-btn button" onclick="closeModal()">Close</button>
          ${actionButtonHTML}
        </div>
      </div>
    `;
  
    // --- Show modal ---
    modal.style.display = "flex";
  }
  
  
  
  let selectedVariantId = null; // add this at top-level
  
  function selectTimeslot(time, element) {
    document.querySelectorAll(".timeslot").forEach((slot) => {
      slot.classList.remove("selected");
    });
    element.classList.add("selected");
    selectedTimeslot = time;
    selectedVariantId = element.dataset.variantId; // store variant ID
  
    document.getElementById(
      "selectedTime"
    ).textContent = `Selected: ${time}`;
  
    const bookBtn = document.getElementById("bookBtn");
    if (bookBtn) {
      bookBtn.disabled = false;
      bookBtn.textContent = window.currentModalEvent ? window.currentModalEvent.popup_btn_text : "Book This Time";
    }
  }
  window.selectTimeslot = selectTimeslot;

  window.bookDirectly = function(eventId, btnElement) {
    const event = window.__processedEvents.find(e => e.id === eventId);
    if (!event || !event.timeslots || event.timeslots.length === 0) return;
    
    btnElement.classList.add("loading");
    btnElement.setAttribute("disabled", true);
    
    addToCartAndOpenDrawer(event.timeslots[0].variantId, 1, event, btnElement);
  };
  
  function bookEvent(productHandle) {
    document.querySelector(".js-modal-btn").classList.add("loading")
    document.querySelector(".js-modal-btn").setAttribute("disabled", true);
    addToCartAndOpenDrawer(selectedVariantId);
  }

  window.bookEvent = bookEvent;

  
  function closeModal() {
    document.getElementById("eventModal").style.display = "none";
    selectedTimeslot = null;
  }
    window.closeModal = closeModal;


  
  // --- Calendar Navigation ---
  function previousMonth() {
    currentDate.setMonth(currentDate.getMonth() - 1);
    updateMonthTitle();
    renderCalendar(currentFilterProduct, currentFilterLocation);
  }
   window.previousMonth = previousMonth;
  
  function nextMonth() {
    currentDate.setMonth(currentDate.getMonth() + 1);
    updateMonthTitle();
    renderCalendar(currentFilterProduct, currentFilterLocation);
  }
     window.nextMonth = nextMonth;
  
  function updateMonthTitle() {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    document.getElementById("monthTitle").textContent = `${
      monthNames[currentDate.getMonth()]
    } ${currentDate.getFullYear()}`;
  }
  
  function populateLocationFilter() {
    try {
      const filterLocation = document.getElementById("filter-location");
      if (!filterLocation) return;
      
      const currentSelected = filterLocation.value;
      const locations = new Set();
      
      events.forEach(event => {
        let loc = event.location;
        if (!loc) return;
        
        if (typeof loc === 'string' && loc.trim() !== "") {
          locations.add(loc.trim());
        } else if (Array.isArray(loc)) {
          loc.forEach(l => {
            if (typeof l === 'string' && l.trim() !== "") {
              locations.add(l.trim());
            }
          });
        }
      });

      // Clear existing options except 'All locations'
      filterLocation.innerHTML = '<option value="all" selected>All locations</option>';
      
      Array.from(locations).sort().forEach(loc => {
        const option = document.createElement("option");
        option.value = loc;
        option.textContent = loc;
        filterLocation.appendChild(option);
      });
      
      if (locations.has(currentSelected)) {
        filterLocation.value = currentSelected;
      }
    } catch (err) {
      console.error("Error populating location filter:", err);
    }
  }

  // --- Init ---
  updateMonthTitle();
  populateLocationFilter();
  renderCalendar();
  renderEventsList();
  
  document.getElementById("eventModal").addEventListener("click", function (e) {
    if (e.target === this) {
      closeModal();
    }
  });
  
  
  
  // --- Filters ---
  document.getElementById("filter-product").addEventListener("change", (e) => {
    currentFilterProduct = e.target.value;
    currentFilterLocation = document.getElementById("filter-location").value;
    renderCalendar(currentFilterProduct, currentFilterLocation);
    renderEventsList(e.target.value, document.getElementById("filter-location").value);
  });
  
  document.getElementById("filter-location").addEventListener("change", (e) => {
    currentFilterLocation = e.target.value;
    currentFilterProduct = document.getElementById("filter-product").value;
    renderCalendar(currentFilterProduct, currentFilterLocation);
    renderEventsList(document.getElementById("filter-product").value, e.target.value);
  });
  
  
  function addToCartAndOpenDrawer(variantId, quantity = 1, directEvent = null, btnElement = null) {
    if (!variantId) return;
    const event = directEvent || window.currentModalEvent;
    if (!event) return;
    const properties = {};
    if (event.location) properties["Location"] = event.location;
    if (event.description) properties["Note"] = event.description;
  
    // Add item to cart using Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity, properties }]
      })
    })
      .then(response => response.json())
      .then(data => {
        if (btnElement) {
          btnElement.classList.remove("loading");
          btnElement.removeAttribute("disabled");
        } else {
          document.querySelector(".js-modal-btn")?.classList.remove("loading");
          document.querySelector(".js-modal-btn")?.removeAttribute("disabled");
        }
        closeModal();
        // Refresh mini-cart (if exists)
        const miniCart = document.querySelector('mini-cart');
        if (miniCart) {
          fetch(miniCart.dataset.url)    
            .then(response => response.text())
            .then(html => {
              document.getElementById('mini-cart').innerHTML =
                miniCart.getSectionInnerHTML(html, '.shopify-section');
  
              miniCart.updateDrawerProperty();
              miniCart.open();
            })
            .catch(e => console.error('Error refreshing mini-cart:', e));
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Failed to add item to cart. Please try again.');
      });
  }
  
  function closeModal() {
    const modal = document.getElementById('eventModal');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  
    //  When popup closes
    document.body.classList.remove('no-scroll');
  }
}


document.addEventListener('shopify:section:load', () => {
  loadAllEventProducts().then(() => {
  mainTicketCalendar();
});
});
document.addEventListener('shopify:section:unload', () => {
  loadAllEventProducts().then(() => {
  mainTicketCalendar();
});
});
document.addEventListener('shopify:section:select', () => {
  loadAllEventProducts().then(() => {
  mainTicketCalendar();
});
});
document.addEventListener('shopify:section:deselect', () => {
  loadAllEventProducts().then(() => {
  mainTicketCalendar();
});
});

loadAllEventProducts().then(() => {
  mainTicketCalendar();
});



